import { InvestmentType } from 'src/app/shared/enums/InvestmentType.enum';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { ReportFAQReqRes } from 'src/app/shared/models/reportFAQReqRes.model';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { ReportFileReqRes } from 'src/app/shared/models/ReportFileReqRes.model';
import ReportFileType from 'src/app/shared/enums/ReportFileType.enum';
import {HoldingReportReqRes} from './HoldingReportReqRes';

export class AssetReportReqRes extends HoldingReportReqRes{
  public assetUpdates: string;
  public tenantsUpdates: string;
  public cashFlowUpdates: string;
  public marketUpdates: string;

  /* #region  Obsolete properties - will not be included in new reports */
  public occupancy: number;
  public investmentType: InvestmentType;
  /* #endregion */

  public plannedCostsToDate: number;
  public actualCostsToDate: number;
  public outstandingLoanAmountToDate: number;
  public constructionStartDate: Date;
  public constructionEndDate: Date;

  private generateReportFile(metaFileLinkUrl: string, reportFileType: ReportFileType, fileMediaType: string, title = ''): ReportFileReqRes {
    return {
      id: 0, metaFileLinkId: 0, url: '',
      fileType: reportFileType,
      metaFileLink: {
        id: 0, title: title, sizeB: 1000, documentType: 0, mediaType: fileMediaType,
        url: metaFileLinkUrl,
      },
    };
  }

  populateAsDummy(appSettingsService: AppSettingsService) {
    this.id =
      this.assetId = TerraUtils.consts.EXAMPLE_ASSET_ID;

    this.totalCapitalization = 5500000;
    this.totalEquityInvestedToDate = 5500000;
    this.totalReturnsToDate = 50000;
    this.investmentType = InvestmentType.Core;
    const date = new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDay(), 13, 0);
    this.periodStartDate = new Date(date.getFullYear(), 0, 1, 13, 0);
    this.periodEndDate = new Date(date.getFullYear(), 2, 31, 13, 0);
    this.publishDate = this.periodEndDate;
    this.netIncome = 50000;
    this.expenses = 17500;
    this.netOperatingIncome = 32500;
    this.occupancy = 95;
    this.summary = 'Highlights of the report period and other important news.';
    this.assetUpdates = 'Relevant updates about the property itself, like renovation progress, repairs, issues with potential impact on finances, etc.';
    this.tenantsUpdates = 'Incoming or outgoing tenants, occupancy rates, etc.';
    this.cashFlowUpdates = 'Details about financials, material expenditures, loan status, etc.';
    this.marketUpdates = 'News about changes in the asset’s proximity, like potential acquisitions, leases, developments that may affect property value, etc.';

    this.faQs = new Array<ReportFAQReqRes>();

    const faq1 = new ReportFAQReqRes();
    faq1.id = 1;
    faq1.question = 'What\'s the income from the recently renovated floor and what\'s the expected increase in rent?';
    faq1.answer = 'The 10 apartments in the floor generated approx $20,000 per month prior to the renovation. We expect this amount to increase to approx $25,000 within 3-6 months as new tenants move in.';
    this.faQs.push(faq1);

    const faq2 = new ReportFAQReqRes();
    faq2.id = 2;
    faq2.question = 'How long will it take to complete renovation of all apartments in the building?';
    faq2.answer = 'We\’re aiming to complete renovation by the end of this year.';
    this.faQs.push(faq2);

    this.attachments = new Array<ReportFileReqRes>();

    this.attachments.push(
      this.generateReportFile(appSettingsService.blobStorageUrlCDN + 'assets/images/example-asset-report-image-1.jpg', ReportFileType.ReportMedia, 'image/jpeg'));

    this.attachments.push(
      this.generateReportFile(appSettingsService.blobStorageUrlCDN + 'assets/images/example-asset-report-image-2.jpg', ReportFileType.ReportMedia, 'image/jpeg'));

    this.attachments.push(
      this.generateReportFile(appSettingsService.blobStorageUrlCDN + 'assets/images/example-asset-report-image-3.jpg', ReportFileType.ReportMedia, 'image/jpeg'));

    this.attachments.push(
      this.generateReportFile(appSettingsService.blobStorageUrlCDN + 'assets/images/example-asset-report-image-4.jpg', ReportFileType.ReportMedia, 'image/jpeg'));

    this.attachments.push(
      this.generateReportFile(appSettingsService.blobStorageUrlCDN + 'assets/images/example-asset-excel.xlsx', ReportFileType.ReportMedia, 'ms-excel', 'Signed_Tax_invoice_Reciept_No_41281…'));

    this.attachments.push(
      this.generateReportFile(appSettingsService.blobStorageUrlCDN + 'assets/images/example-asset-pdf.pdf', ReportFileType.ReportMedia, 'pdf', 'Signed_Tax_invoice_Reciept_No_41281…'));

    this.attachments.push(
      this.generateReportFile(appSettingsService.blobStorageUrlCDN + 'assets/images/example-asset-pdf.pdf', ReportFileType.ReportDocument, 'pdf', 'Report PDF'));
  }
}

